import React from 'react'
import Text from '../../../components/text/Text'
import {IPro} from '../../../apis/user/getProHistoryList'
import {useTag} from '../../../utils/etc'
import Span from '../../../components/text/Span'
import {useTime} from '../../../utils/time'
import {IUserData} from '../../../apis/user/getUserDetail'
import {useExchange} from '../../../utils/exchnage'

interface IProps {
    className?: string
    userId?: string
    pro?: IPro
    data: IUserData
}

const UserProContainer: React.FC<IProps> = ({className, userId, pro, data}) => {
    const nameTagClassName = 'text-ti3 text-font03'
    const {renderProPaymentColor, renderStateColor} = useTag()
    const {convertUtc0ToUtc9} = useTime()
    const {getExchangeData} = useExchange()

    const isCheckOverEndAt = endAt => {
        if (new Date(endAt).getTime() < new Date().getTime()) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={'space-y-[30px]'}>
            <div className={`bg-white rounded-[10px] p-[30px] shadow-normal ${className}`}>
                <Text className={'text-h3'}>Last Pro Payment</Text>
                <div
                    className={
                        'mt-[30px] grid grid-cols-4 text-center gap-y-[30px] gap-x-[10px] md:grid-cols-3 sm:grid-cols-2'
                    }>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>Chain</Text>
                        <Text>{pro?.chain || '-'}</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>Pay Method</Text>
                        <Text className={`${renderProPaymentColor(pro?.pay_method)} mx-auto`}>{pro?.pay_method}</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>Period</Text>
                        <Text>{pro?.period} Month</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>
                            Amount <Span className={'text-body3 text-font03'}>(입금액)</Span>
                        </Text>
                        <Text>$ {pro?.amount}</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>tx_id</Text>
                        <Text className={'w-[150px] mx-auto break-all text-body3 sm:w-full'}>{pro?.tx_id}</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>Start At</Text>
                        <Text>{convertUtc0ToUtc9(pro?.start_at)}</Text>
                    </div>
                    <div className={'space-y-[10px]'}>
                        <Text className={nameTagClassName}>End At</Text>
                        <div className={''}>
                            <Text className={`break-keep ${isCheckOverEndAt(pro?.end_at) && 'text-font_red'}`}>
                                {convertUtc0ToUtc9(pro?.end_at)}
                            </Text>
                            {isCheckOverEndAt(pro?.end_at) && (
                                <div className={`${renderStateColor(false)} mx-auto mt-[10px]`}>Overdue</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserProContainer
